import { render, staticRenderFns } from "./TabbedEditorHeaderCard.vue?vue&type=template&id=5ce96af6&scoped=true"
import script from "./TabbedEditorHeaderCard.vue?vue&type=script&lang=js"
export * from "./TabbedEditorHeaderCard.vue?vue&type=script&lang=js"
import style0 from "./TabbedEditorHeaderCard.vue?vue&type=style&index=0&id=5ce96af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce96af6",
  null
  
)

export default component.exports